<template>
  <div>
    <div class="card flex-row is-smallshadow mt-2 py-2 px-2 mx-auto">
      <f-button
        class="text-uppercase pr-1-sm"
        theme="go-back"
        withArrow
        withArrowBackwards
        @click.prevent="$bus.$emit('inquiry-offers-show-list')" >
        <span v-pure-html="$t('inquiryOfferForm.backToComparingOffer')"></span>
      </f-button>
    </div>

    <div class="card mt-2 mb-5 mx-auto">
      <div
        class="card-body form-readonly relative"
        style="min-height: 200px;">
        <h3 class="heading-medium mb-3">
          <span class="block mb-1">
            {{ $t('inquiryOfferLoanSimulation.ratesInstallmentsSimulation') }} {{ lendingRateType === 'fixed' ? 'stałym' : 'zmiennym' }}
          </span>
          <small class="block text-size-medium">
            {{ $t('inquiry.titleMobile') }}: <span class="text-light-blue">{{ userType === 'customer' ? offer.customer_description_bank_offer || '-' : offer.bank_offer_name }}</span>
          </small>
          <small
            v-if="offer.bank_offer_variant_id"
            class="block text-size-medium">
            {{ $t('ui.variant') }}: <span class="text-light-blue">{{ userType === 'customer' ? offer.customer_description_bank_variant_offer || '-' : offer.bank_offer_variant_name }}</span>
          </small>
        </h3>
        <template v-if="loaded && !loadError">
          <h4 class="heading-small text-grey">{{ $t('inquiryOfferLoanSimulation.creditTermsAndConditions') }}</h4>
          <div class="form-group">
            <label for="property-value">{{ $t('inquiryOfferLoanSimulation.creditAmount') }}</label>
            {{ simulation.conditions.credit_amount }} PLN
          </div>
          <div class="form-group">
            <label for="property-value">{{ $t('inquiryOfferLoanSimulation.rateInterest') }}</label>
            {{ simulation.conditions.lending_rate }} %
          </div>
          <div class="form-group">
            <label for="property-value">{{ $t('inquiryOfferLoanSimulation.repaymentPeriod') }}</label>
            {{ simulation.conditions.years }} {{ $t('ui.years') }}
          </div>
          <div class="form-group">
            <label for="property-value">{{ $t('inquiryOfferLoanSimulation.methodOfRepayment') }}</label>
            {{ installmentTypeForDisplay }}
          </div>
          <div class="form-group">
            <label for="property-value">{{ $t('inquiryOfferLoanSimulation.numberOfInstallments') }}</label>
            {{ simulation.conditions.instalments_count }}
          </div>

          <h4 class="heading-small text-grey mt-4">{{ $t('inquiryOfferLoanSimulation.installmentPlan') }}</h4>

          <f-list
            class="loan-simulation-list"
            :loaded="loaded"
            :listSettings="listSettings"
            :listItems="simulation.instalments"
            :isPlain="true" />

        </template>
        <template v-else>
          <div
            v-if="!loaded && !loadError"
            class="loading-spinner-wrapper">
            <div class="loading-spinner pb-3 pt-5">
              <span class="loading-spinner-content">
                {{ $t('ui.loadingDataInProgress') }}&hellip;
              </span>
            </div>
          </div>
          <div class="wrapper mt-3">
            <f-alert
              v-if="loadError"
              theme="warning"
              visible>
              <span>
                {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
              </span>
            </f-alert>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import InstallmentTypes from '@/data/installment-types.js';

export default {
  name: 'inquiry-offer-loan-simulation',
  props: {
    lendingRateType: {
      required: true,
      type: String
    },
    offer: {
      required: true,
      type: Object
    }
  },
  computed: {
    installmentTypeForDisplay() {
      let insType = InstallmentTypes.find((element) => element.value === this.simulation.conditions.type);

      if (insType) {
        return insType.text;
      }

      return '';
    },
  },
  data () {
    return {
      listSettings: [{
        title: this.$t('inquiryOfferLoanSimulation.numberInstallment'),
        type: 'String',
        variableName: ['number']
      }, {
        title: this.$t('inquiryOfferLoanSimulation.monthInstallment'),
        type: 'String',
        variableName: ['month_instalment']
      }, {
        title: this.$t('inquiryOfferLoanSimulation.interest'),
        type: 'String',
        variableName: ['interest']
      }, {
        title: this.$t('inquiryOfferLoanSimulation.capital'),
        type: 'String',
        variableName: ['capital']
      }, {
        title: this.$t('inquiryOfferLoanSimulation.creditCondition'),
        type: 'String',
        variableName: ['credit_condition']
      }],
      loaded: false,
      loadError: false,
      simulation: null,
      userType: null,
    }
  },
  mounted () {
    this.userType = this.$store.getters['getUserType'].toLowerCase();
    this.loadSimulationData();
  },
  methods: {
    loadSimulationData() {
      let lendingRate = this.offer.lending_rate;

      if (this.lendingRateType === 'fixed') {
        lendingRate = this.offer.fixed_lending_rate;
      }

      let requestParams = {
        type: 'EQUAL',
        credit_amount: this.offer.credit_amount,
        years: 25,
        lending_rate: lendingRate
      }

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/api/loan-calculator/calculate',
        loadedKey: 'loaded',
        errorKey: 'loadError',
        outputKey: 'simulation',
        pagination: false,
        params: requestParams
      });
    },
  },
  beforeDestroy () {
  }
}
</script>
